import { Form, Formik } from "formik";
import {
  APPLY_BUTTON_STYLE,
  HOOK_LOADER_DUMPSITE_OPTIONS,
  HOOK_LOADER_FCTS_OPTIONS,
  RESET_BUTTON_STYLE,
} from "./reportCommon";
import { DEFAULT_HOOK_LOADER_INNER_FILTERS } from "./staticReportData";
import Select from "react-select";
const HookLoaderInnerFilter = ({
  initialValues = DEFAULT_HOOK_LOADER_INNER_FILTERS,
  wardOptions = [],
  fctsOptions = HOOK_LOADER_FCTS_OPTIONS,
  lockedVehicleNo = "",
  onSearch,
  onReset,
}) => (
  <Formik
    initialValues={initialValues}
    enableReinitialize
    onSubmit={(values) =>
      onSearch?.({
        ...values,
        vehicleNo: lockedVehicleNo || values.vehicleNo,
      })
    }
  >
    {({ values, setFieldValue, resetForm, handleSubmit }) => (
      <Form onSubmit={handleSubmit}>
        <div className="row align-items-end">
          <div className="col-md-3 mb-3">
            <label className="form-label">Ward</label>
            <select
              name="wardId"
              value={values.wardId}
              onChange={(event) => setFieldValue("wardId", event.target.value)}
              className="form-select bg-white"
            >
              <option value="">Select Ward</option>
              {wardOptions.map((ward) => (
                <option key={ward.wardId} value={ward.wardId}>
                  {ward.wardName}
                </option>
              ))}
            </select>
          </div>

          <div className="col-md-3 mb-3">
            <label className="form-label">HL Vehicle</label>
            {lockedVehicleNo ? (
              <input
                type="text"
                name="vehicleNo"
                value={lockedVehicleNo}
                disabled
                className="form-control bg-white"
              />
            ) : (
              <input
                type="text"
                name="vehicleNo"
                value={values.vehicleNo}
                onChange={(event) =>
                  setFieldValue("vehicleNo", event.target.value)
                }
                className="form-control bg-white"
                placeholder="Enter HL vehicle no"
              />
            )}
          </div>

          <div className="col-md-3 mb-3">
            <label className="form-label">FCTS</label>
             <Select
              name="dumpsiteId"
              options={fctsOptions}
              value={
                fctsOptions.find(
                  (option) => String(option.value) === String(values.dumpsiteId)
                ) || null
              }
              onChange={(selectedOption) =>
                setFieldValue("dumpsiteId", selectedOption?.value || "")
              }
              placeholder="Select Dumpsite"
              isSearchable
              isClearable
              styles={{
        menu: (provided) => ({
          ...provided,
          zIndex: 9999,
        }),
      }}
        />
          </div>

          <div className="col-md-3 mb-3">
  <label className="form-label">Dumpsite</label>

        <Select
              name="dumpsiteId"
              options={fctsOptions}
              value={
                fctsOptions.find(
                  (option) => String(option.value) === String(values.dumpsiteId)
                ) || null
              }
              onChange={(selectedOption) =>
                setFieldValue("dumpsiteId", selectedOption?.value || "")
              }
              placeholder="Select Dumpsite"
              isSearchable
              isClearable
              styles={{
        menu: (provided) => ({
          ...provided,
          zIndex: 9999,
        }),
      }}
        />
      </div>

          <div className="col-md-3 mb-3">
            <label className="form-label">From Date &amp; Time</label>
            <input
              type="datetime-local"
              name="fromDateTime"
              value={values.fromDateTime}
              onChange={(event) =>
                setFieldValue("fromDateTime", event.target.value)
              }
              className="form-control bg-white"
            />
          </div>

          <div className="col-md-3 mb-3">
            <label className="form-label">To Date &amp; Time</label>
            <input
              type="datetime-local"
              name="toDateTime"
              value={values.toDateTime}
              min={values.fromDateTime || undefined}
              onChange={(event) =>
                setFieldValue("toDateTime", event.target.value)
              }
              className="form-control bg-white"
            />
          </div>

          <div className="col-md-3 mb-3 d-flex gap-2">
            <button type="submit" style={APPLY_BUTTON_STYLE}>
              APPLY FILTERS
            </button>
            <button
              type="button"
              style={RESET_BUTTON_STYLE}
              onClick={() => {
                const resetValues = {
                  ...DEFAULT_HOOK_LOADER_INNER_FILTERS,
                  vehicleNo: lockedVehicleNo || "",
                };
                resetForm({ values: resetValues });
                onReset?.();
              }}
            >
              RESET
            </button>
          </div>
        </div>
      </Form>
    )}
  </Formik>
);

export default HookLoaderInnerFilter;
